import { Nullable } from './utils';

export enum RegisteredAgentRenewalAction {
  CONTINUE = 'CONTINUE',
  OPTOUT = 'OPTOUT',
}

export type RegisteredAgentInList = {
  id: number;
  companyId: number;
  companyName: string;
  companyFormationDate: Nullable<string>;
  registeredAgentLastDecision: Nullable<RegisteredAgentRenewalAction>;
  registeredAgentLastDecisionAt: Nullable<string>;
  registeredAgentLastEmailSentAt: Nullable<string>;
};

export enum RegisteredAgentStatusFilter {
  ACTIVE = 'active',
  OPTED_OUT = 'opted_out',
  ALL = 'all',
}

export type RegisteredAgentRenewalActionResponse = {
  companyLlcId: number;
  companyName: string;
  action: RegisteredAgentRenewalAction;
};
